import React from 'react';
import { formatDate } from '../utils/dateutils';

const Event = (props) => {
  const { event, localizer: { messages } } = props;
  
  // Handles the event click action
  // e: The click event triggered by the event div
  const onEventClick = (e) => {
    if (e.target.tagName.toLowerCase() === 'a') {
      return; // Prevent onEventClick if the target is an anchor tag
    }
    const { drilldownView } = props;
    document.querySelector(`[data-key=${drilldownView}]`).click();
  }

  return (
		<div
			className="oec-custom-event"
			data-slot-start={formatDate(event.start)}
			data-slot-end={formatDate(event.end)}
			onClick={onEventClick}
		>
			<h2 className="oec-event-title" style={{backgroundColor: event.legend_color, color: event.text_color}}>{event.title}</h2>
			<section className="oec-event-details">
				<p className="oec-event-description">{event.description}</p>
				{event.details_url && <a
					href={event.details_url}
					target="_blank"
					rel="noopener noreferrer"
					className="oec-event-link"
				>
					{messages.eventLinkText || event.details_url}
				</a>}
			</section>
		</div>
	);
};

export default Event;
